import { Component, OnDestroy } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { Subscription } from 'rxjs';

export interface IAgHeaderCheckbox {
  updateChecked(isChecked: boolean);
  updateLimit(limit: number);
}

@Component({
    selector: 'app-ag-header-checkbox',
    templateUrl: './ag-header-checkbox.component.html',
    styleUrls: ['./ag-header-checkbox.component.scss'],
    imports: [MatCheckbox, FormsModule, MatTooltip]
})
export class AgHeaderCheckboxComponent implements IHeaderAngularComp, OnDestroy {

  params: IHeaderParams<any, any>;
  limit = 0;
  checked = false;
  private allSelectedSub?: Subscription;

  agInit(params: IHeaderParams<any, any>): void {
    this.params = params;
    this.limit = params.context.componentParent.batchEditLimit;
    this.allSelectedSub = this.params.context.componentParent.allSelected.subscribe(result => {
      this.checked = result;
    });
  }

  refresh(params: IHeaderParams<any, any>): boolean {
    return false;
  }

  updateChecked(isChecked: boolean) {
    this.checked = isChecked;
  }

  updateLimit(limit: number) {
    this.limit = limit;
  }

  onChange() {
    this.params.context.componentParent.currentPageRows.forEach((id: string) => {
      this.params.api?.getRowNode(id)?.setSelected(this.checked);
    });
  }

  ngOnDestroy(): void {
    this.allSelectedSub?.unsubscribe();
  }

}
